<kilowant-header title="Clients"></kilowant-header>
<div class="wrapperMain mainAccountDetailsMain accountDetails">
  <div class="form buyer">
    <div class="mt-10 mb-10 d-flex">
      <select name="viewClientsType" class="grey-select f14" [(ngModel)]="viewClientsType" (change)="changeClientView()">
        <option value="all">All</option>
        <option value="residential">Residential</option>
        <option value="commercial">Commercial</option>
      </select>
      <select name="viewActiveType" class="grey-select f14 ml-10" [(ngModel)]="viewActiveType" (change)="changeClientView()">
        <option value="all">All</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </select>
    </div>
    <input type="text" name="keywords" placeholder="SEARCH" class="ml-10 search-clients" [(ngModel)]="keywords" (ngModelChange)="searchSiteInputChanged($event)" (keydown)="searchSiteInputChanged($event)" />
    <div>
      <table mat-table matSort [dataSource]="clients" matSortActive="ClientName" matSortDisableClear="true"
        matSortDirection="asc" class="offer-summmary-table in-card-table background-transparent" multiTemplateDataRows>
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef class="text-center">&nbsp;&nbsp;</th>
          <td mat-cell *matCellDef="let element; let rowIdx = dataIndex;" class="text-center">
            {{currentStart+rowIdx+1}}
          </td>
        </ng-container>
        <ng-container matColumnDef="ClientName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
          <td mat-cell *matCellDef="let element" class="cursor-pointer long-text-cut"> {{element.clientName}}</td>
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" class="no-border" [attr.colspan]="displayedColumns.length">
              <div>
                @if (client!=null && element.clientId === client.id) {
                  <div class="card">
                      <div class="table-view">
                          <div class="row">
                              <div class="cell">
                                  <input type="text" name="FirstName" [class]="getClassesForInput('FirstName', true, client.firstName)" (input)="resetError('FirstName')" placeholder="First name" [(ngModel)]="client.firstName" [minlength]="validationService.getMinLength('User', 'firstName')" [maxlength]="validationService.getMaxLength('User', 'firstName')" />
                                  @if (getVisibilityForLabel(client.firstName)) {
                                  <div class="placeholder">First name</div>
                                  }
                              </div>
                              <div class="cell">
                                  <input type="text" name="LastName" [class]="getClassesForInput('LastName', true, client.lastName)" (input)="resetError('LastName')" placeholder="Last name" [(ngModel)]="client.lastName" [minlength]="validationService.getMinLength('User', 'lastName')" [maxlength]="validationService.getMaxLength('User', 'lastName')" />
                                  @if (getVisibilityForLabel(client.lastName)) {
                                  <div class="placeholder">Last name</div>
                                  }
                              </div>
                          </div>
                      </div>
                      <div class="mb-10" *ngIf="isCommercial">
                          <input type="text" name="Company" [class]="getClassesForInput('Company', true, client!.company!.name)" (input)="resetError('Company')" placeholder="Company" [(ngModel)]="client!.company!.name" [minlength]="validationService.getMinLength('Company', 'name')" [maxlength]="validationService.getMaxLength('Company', 'name')" />
                          @if (getVisibilityForLabel(client!.company!.name)) {
                          <div class="placeholder">Company</div>
                          }
                      </div>
                      <input type="text"
                             name="addressLine1"
                             [class]="getClassesForInput('addressLine1', true, client.addressLine1)"
                             (input)="resetError('addressLine1')"
                             placeholder="Address Line"
                             [(ngModel)]="client.addressLine1"
                             [minlength]="validationService.getMinLength('User', 'address')"
                             [maxlength]="validationService.getMaxLength('User', 'address')" />
                      @if (getVisibilityForLabel(client.addressLine1)) {
                      <div class="placeholder">Address Line</div>
                      }
                      <div class="cols">
                          <div class="col">
                              <select [class]="getClassesForInput('stateId', true, 'ST')"
                                      [compareWith]="compareFn"
                                      name="stateId"
                                      style="width: 60px !important;"
                                      (change)="resetError('stateId'); filterCities();"
                                      [(ngModel)]="client.state">
                                  @if (client.state==null) {
                                  <option [ngValue]="null" [disabled]="true">ST</option>
                                  }
                                  @for (state of states; track state) {
                                  <option [ngValue]="state">{{state.stateCode}}</option>
                                  }
                              </select>
                              @if (getVisibilityForLabel((client.state==null)?null:client.state.name)) {
                              <div class="placeholder">State</div>
                              }
                          </div>
                          <div class="col">
                              <select [class]="getClassesForInput('city', true, client.city)"
                                      name="city"
                                      (change)="resetError('city');"
                                      [(ngModel)]="client.city">
                                  @if (client.city==null) {
                                  <option [ngValue]="null" [disabled]="true">City</option>
                                  }
                                  @for (city of cities; track city) {
                                  <option [ngValue]="city">{{city}}</option>
                                  }
                              </select>
                              @if (getVisibilityForLabel(client.city)) {
                              <div class="placeholder">City</div>
                              }
                          </div>
                          <div class="col">
                              <input type="text"
                                     name="address"
                                     [class]="getClassesForInput('zip', true, client.zip)"
                                     style="min-width: 80px"
                                     (input)="resetError('zip')"
                                     placeholder="Zip"
                                     [(ngModel)]="client.zip"
                                     [minlength]="validationService.getMinLength('User', 'zip')"
                                     [maxlength]="validationService.getMaxLength('User', 'zip')" />
                              @if (getVisibilityForLabel(client.zip)) {
                              <div class="placeholder">Zip</div>
                              }
                          </div>
                      </div>
                      <input type="text" name="Phone"
                             [class]="getClassesForInput('Phone', true, (((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+((focusedField()=='Phone')?'1':'')))"
                             (input)="resetError('Phone')"
                             placeholder="Mobile Phone"
                             [dropSpecialCharacters]="false"
                             [formControl]="currentPhoneNumber"
                             (focus)="focusField('Phone')"
                             mask="(000) 000-0000"
                             [showMaskTyped]="(focusedField()=='Phone')||(currentPhoneNumber.value!=null && currentPhoneNumber.value?.trim()!='' && !currentPhoneNumber.value.valid)" />
                      @if (getVisibilityForLabel(((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+((focusedField()=='Phone')?'phone':''))) {
                      <div class="placeholder">Mobile Phone</div>
                      }
                      <input type="text" name="Email" class="w-100" [class]="getClassesForInput('Email', true, client.email)"
                          disabled="disabled"   value="" (input)="resetError('Email')" [(ngModel)]="client.email" placeholder="Email" />
                      @if (getVisibilityForLabel(client.email)) {
                      <div class="placeholder">Email</div>
                      }
                      <label><input type="checkbox" name="active" [(ngModel)]="client.isActive" [checked]="client.isActive" /> Client is active</label>

                      @if (client!=null && client.company!=null) {
                      <div>
                          <div class="mb-10 mt-10">
                              <label>
                                  <input type="checkbox" name="taxExempt" [(ngModel)]="client!.company!.taxExempt" /> Is your business
                                  tax exempt?
                              </label>
                          </div>
                          @if (client!.company!.taxExempt) {
                          <div>
                              <input type="text" name="FederalTaxID" class="w-100"
                                     [class]="getClassesForInput('FederalTaxID', true, client!.company!.federalTaxID)" value=""
                                     (input)="resetError('FederalTaxID')" [(ngModel)]="client!.company!.federalTaxID"
                                     placeholder="Federal Tax ID" />
                              @if (getVisibilityForLabel(client!.company!.federalTaxID)) {
                              <div class="placeholder">Federal Tax ID</div>
                              }
                              <div class="mt-20"> Please upload a photo or a copy of your tax exempt certificate.</div>
                              @if ((fileToUpload==null) && client!.company!.taxExemptCertificateDocument==null) {
                              <label class="formLabel"
                                     [class]="(errorY().isWrong('fileToUpload'))?'error':''">
                                  CHOOSE FILES
                                  <span>no files selected</span>
                                  <input type="file" name="taxExemptCertificateDocument" class="required" value=""
                                         placeholder="Tax Exempt Certificate Document" (change)="handleFileInput($event)" />
                              </label>
                              }
                              @if (fileToUpload!=null || client!.company!.taxExemptCertificateDocument!=null) {
                              <div class="files-list">
                                  <span>File selected</span>
                                  <ul>
                                      @if (client!.company!.taxExemptCertificateDocument!=null) {
                                      <li>
                                          <a (click)="deleteExistingFile(client!.company!.taxExemptCertificateDocument.key)"></a>
                                          <div class="link" (click)="downloadFile(true, client!.company!.taxExemptCertificateDocument.key)">{{client!.company!.taxExemptCertificateDocument.value}}</div>
                                      </li>
                                      }
                                      @if (fileToUpload!=null) {
                                      <li>
                                          <a (click)="deleteFile()"></a>
                                          <div class="link" (click)="downloadFile(false, null)">{{fileToUpload.name}}</div>
                                      </li>
                                      }
                                  </ul>
                              </div>
                              }
                          </div>
                          }
                      </div>
                      }

                      @if (this.errorY().showError()) {
                      <div class="error-block">{{this.errorY().error}}</div>
                      }
                      <div class="block-buttons full-width small mt-20">
                          <button type="button" (click)="cancel()">Cancel</button>
                          <button type="button" (click)="updateClient()">Update</button>
                          <button type="button" [disabled]="element.hasActivity" (click)="deleteClient(client)">Delete</button>
                      </div>
                  </div>
                      }
                    </div>
                  </td>
                </ng-container>
              </ng-container>
              <ng-container matColumnDef="AccountCount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Accts </th>
                <td mat-cell *matCellDef="let element" class="cursor-pointer long-text-cut">
                  {{element.numberAccounts}}
                </td>
              </ng-container>
              <ng-container matColumnDef="NextAvailableDate">
                <th mat-header-cell *matHeaderCellDef> Exp </th>
                <td mat-cell *matCellDef="let element" class="cursor-pointer long-text-cut">
                  {{element.nextAvailableDate | date:'shortDate'}}
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let element; let row; columns: displayedColumns;" (click)="editClient(element.clientId)" [class]="((this.client!=null && (element.clientId==this.client.id))?'selected':'') + ((element.isActive)?'':' inactive')"></tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="b-none"></tr>
            </table>
            <mat-paginator [length]="total" hidePageSize="true" [pageSize]="RECS_PER_PAGE" aria-label="Select page"></mat-paginator>
          </div>
        </div>
        <div class="block-buttons mt-10 under-card">
          <button type="button" (click)="downloadReport()">Download Report</button>
          <button type="button" (click)="addClient()">Add Client</button>
        </div>
      </div>